<script setup lang="ts">
import { useUspItems } from '@/composables/useUspItems';

const { uspItems } = useUspItems();
</script>

<template>
	<div class="w-full flex flex-nowrap overflow-hidden text-sm desktop:text-lg">
		<ul class="leading-relaxed font-normal h-full justify-center flex animate-infinite-scroll">
			<li
				v-for="uspItem in uspItems"
				:key="uspItem.icon"
				class="flex items-center justify-start gap-2 desktop:gap-3 whitespace-nowrap mx-2 desktop:mx-4"
			>
				<div class="flex justify-center">
					<FontAwesomeIcon
						:icon="uspItem.icon"
						class="text-green-300 h-6 lg:h-8"
					/>
				</div>
				<p>{{ uspItem.text }}</p>
			</li>
		</ul>
		<ul class="leading-relaxed font-normal h-full justify-center flex animate-infinite-scroll">
			<li
				v-for="uspItem in uspItems"
				:key="uspItem.icon"
				class="flex items-center justify-start gap-2 desktop:gap-3 whitespace-nowrap mx-2 desktop:mx-4"
			>
				<div class="flex justify-center">
					<FontAwesomeIcon
						:icon="uspItem.icon"
						class="text-green-300 h-6 lg:h-8"
					/>
				</div>
				<p>{{ uspItem.text }}</p>
			</li>
		</ul>
	</div>
</template>
